<template>
  <!-- InvoiceToEAS -->
  <el-tab-pane label="InvoiceToEAS">
    <div>
      <div class="row">
        <div class="col-sm-12">
          <el-card>
            <h4 style="color: #3b291d">InvoiceToEAS =>
              <!-- <span v-if="dcName === 'hk'" style="color: red">{{ dcName }}</span>
              <span v-else style="color:blue">{{ dcName }}</span> -->
              <el-switch v-model="searchKey.SendDCName" class="ml-2" inline-prompt size="large"
                style="--el-switch-on-color:red ; --el-switch-off-color: blue" active-text="hk" active-value="hk"
                inactive-text="hktest" inactive-value="hktest" />
            </h4>
            <!-- Start search part -->
            <div class="row" style="margin-top: 20px">
              <div class="col-sm-2">
                <base-input label="InvoiceNumber / ContractNo">
                  <el-input placeholder="InvoiceNumber / ContractNo" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="SendData.SendInvoiceNumber"></el-input>
                </base-input>

              </div>
              <div class="col-sm-1">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="danger" @click="PushDataToEAS(SendData.SendInvoiceNumber)"
                      style="width: 100px">Send</base-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <base-input label="Signed Date" class="range-picker">
                  <el-date-picker type="daterange" placeholder="Signed Date" v-model="SendData.DateList"
                    class="form-control" value-format="YYYY-MM-DD" format="DD/MM/YYYY">
                  </el-date-picker>
                </base-input>
              </div>

              <div class="col-sm-1">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="danger" @click="PushDateDataToEAS(SendData.DateList)"
                      style="width: 100px">Send</base-button>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <base-input label="PaymentDue Date" class="range-picker">
                  <el-date-picker type="daterange" placeholder="PaymentDue Date" v-model="SendData.DateList2"
                    class="form-control" value-format="YYYY-MM-DD" format="DD/MM/YYYY">
                  </el-date-picker>
                </base-input>
              </div>

              <div class="col-sm-1">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="danger" @click="PushDateDataToEAS(SendData.DateList2, 'PaymentDueDate')"
                      style="width: 100px">Send</base-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <base-input label="Invoice Date" class="range-picker">
                  <el-date-picker type="daterange" placeholder="Invoice Date" v-model="SendData.DateList3"
                    class="form-control" value-format="YYYY-MM-DD" format="DD/MM/YYYY">
                  </el-date-picker>
                </base-input>
              </div>

              <div class="col-sm-1">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="danger" @click="PushDateDataToEAS(SendData.DateList3, 'InvoiceDate')"
                      style="width: 100px">Send</base-button>
                  </div>
                </div>
              </div>





            </div>
            <hr />
            <div class="row">
              <div class="col-sm-2">
                <base-input label="CreateDate" class="range-picker">
                  <el-date-picker type="daterange" placeholder="Date" v-model="searchKey.CreateDateList"
                    class="form-control" value-format="YYYY-MM-DD" format="DD/MM/YYYY">
                  </el-date-picker>
                </base-input>
              </div>

              <div class="col-sm-2">
                <base-input label="Result" :clearable="true">
                  <el-select v-model="searchKey.result" class="select-primary" filterable size="large"
                    placeholder="Result">
                    <el-option label="all" value=""> </el-option>
                    <el-option label="fail" value="fail"> </el-option>
                    <el-option label="ok" value="ok"> </el-option>
                  </el-select>
                </base-input>
              </div>
              <div class="col-sm-2">
                <base-input label="DcName" :clearable="true">
                  <el-select v-model="searchKey.dcName" class="select-primary" filterable size="large"
                    placeholder="DcName">
                    <el-option label="all" :value="null"> </el-option>
                    <el-option label="hk" value="hk"> </el-option>
                    <el-option label="hktest" value="hktest"> </el-option>
                  </el-select>
                </base-input>
              </div>

            </div>

            <div class="row">
              <div class="col-sm-2">
                <base-input label="ContentNumber">
                  <el-input placeholder="ContentNumber" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKey.contentNumber"></el-input>
                </base-input>
              </div>

              <div class="col-sm-2">
                <base-input label="InputData">
                  <el-input placeholder="InputData" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKey.inputData"></el-input>
                </base-input>
              </div>

              <div class="col-sm-2">
                <base-input label="ReturnData">
                  <el-input placeholder="ReturnData" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKey.returnData"></el-input>
                </base-input>
              </div>

              <div class="col-sm-3">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="primary" @click="search" style="width: 100px">Search</base-button>
                    <base-button type="primary" @click="resetConfig" style="width: 100px">Reset</base-button>
                    <base-button type="danger" @click="search(true)" style="width: 100px">Send</base-button>
                  </div>
                </div>
              </div>
            </div>
            <hr />



            <!-- end Search part-->
            <div class="row" style="margin-top: 20px">

              <div class="col-sm-12" style="display: flex">
                <span style="
                    margin-left: auto;
                    line-height: 32px;
                    padding-right: 20px;
                  ">
                  <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]" :small="small" :background="true"
                    layout="total, sizes, prev, pager, next, jumper" :total="searchKey.total"
                    @size-change="ChangePageSearchConfig" @current-change="ChangePageSearchConfig" />
                </span>

              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-table :data="Datalist" style="width: 100%" border header-row-class-name="header-row"
                  @filter-change="search" table-layout="auto" cell-class-name="report-cell">
                  <el-table-column prop="dcName" label="DcName" :width="90" />
                  <!-- <el-table-column prop="apiName" label="APIName" :width="150" /> -->
                  <tablecolumn prop="contentNumber" label="ContentNumber" :width="280" />
                  <el-table-column prop="operateType" label="OperateType" :width="120" />
                  <el-table-column prop="inputData" label="InputData">
                    <template #default="scope">
                      <el-popover placement="right" :width="800" trigger="click">
                        <template #reference>
                          <el-button class="m-2">{{ scope.row.inputData != null ? scope.row.inputData.substring(0,
                            80) : null }}</el-button>
                        </template>

                        <div style="overflow-y: auto; ">
                          <pre style=" height: 600px; color: black;font-size: 16px;">{{ scope.row.inputData }}</pre>
                        </div>
                      </el-popover>

                    </template>
                  </el-table-column>


                  <el-table-column prop="returnData" label="ReturnData">
                    <template #default="scope">
                      <el-popover placement="right" :width="800" trigger="click">
                        <template #reference>
                          <el-button class="m-2">{{ scope.row.returnData != null ? scope.row.returnData.substring(0,
                            50) : null }}</el-button>
                        </template>

                        <div style="overflow-y: auto; ">
                          <pre style="height: 600px; color: black;font-size: 16px;">{{ scope.row.returnData }}</pre>
                        </div>
                      </el-popover>

                    </template>
                  </el-table-column>
                  <tablecolumn prop="result" label="Result" :width="120" />
                  <tablecolumn prop="remark" label="Remark" :width="250" />
                  <el-table-column prop="cteateDate" :formatter="formatterCellDateTime" label="CreateDate"
                    :width="320" />
                  <el-table-column prop="" fixed="right" label="Action" class-name="action" :width="190">
                    <template #default="scope">
                      <el-link type="primary" @click="PushDataToEAS(scope.row.contentNumber)">Send</el-link>
                      <el-link style="margin-left: 20px;" type="primary"
                        @click="PushDataToFixed(scope.row.contentNumber)">Fixed</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </el-tab-pane>
</template>

<script setup>
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';
import dateJs from '@/assets/js/date.js';

const currentPage = ref(1);
const pageSize = ref(10);

// router
import profile from '@/network/profile';

// icon
import { ElMessage, ElMessageBox } from 'element-plus';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';
onBeforeMount(async () => {
  await search();
});

//#region Configs
const Datalist = ref([]);
const dcName = ref('');
const IsStarted = ref(false);
const dialogFormOpenUpdateConfig = ref(false);
const ConfigInfoData = reactive({});
const userlist = ref([]);
const SendData = reactive({
  SendInvoiceNumber: '',
  DateList: [
  ],
  DateList2: [
  ],
  DateList3: [
  ],
});

//变更分页
const ChangePageSearchConfig = async (data) => {
  searchKey.pageIndex = currentPage;
  searchKey.pageSize = pageSize;
  search();
};
const searchKey = reactive({
  pageIndex: 1,
  pageSize: 10,
  APIName: "Invoice",
  CreateDateList: [
    `${dateJs.ConvertDate(new Date())}`,
    `${dateJs.ConvertDate(new Date())}`,
  ],
  result: 'fail',
  SendDCName: 'hktest',
});

const search = async (isSend) => {
  searchKey.isSend = false;
  //是否推送数据
  if (isSend == true) {
    var run = await ElMessageBox.confirm('根据搜索条件推送数据 ?', 'Warning [' + searchKey.SendDCName + ']', {
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
    })
      .then(() => {
        searchKey.isSend = isSend;
        return true;
      })
      .catch(() => {

        return false;

      });
    if (run != true) {
      return;
    }
  }
  const search_res = await profile
    .GetEASSendDataList(searchKey)
    .then((res) => res);
  searchKey.total = search_res.data.total;
  Datalist.value = search_res.data.list;
  IsStarted.value = search_res.data.status;
  dcName.value = search_res.data.dcName;
  // userlist.value = search_res.data.userlist;
};

const resetConfig = async () => {
  //清空对象
  Object.keys(searchKey).map((key) => {
    if (key != 'SendDCName') {
      delete searchKey[key];
    }
  });
  searchKey.pageIndex = 1;
  searchKey.pageSize = 10;
  searchKey.APIName = "Invoice";
  searchKey.CreateDateList = [
    // `${dateJs.ConvertDate(new Date())}`,
    // `${dateJs.ConvertDate(new Date())}`,
  ];
  searchKey.result = '';
  search();
};
const PushDataToFixed = async (contentNumber) => {
  ElMessageBox.prompt(`Are you sure selected (${contentNumber}) are fixed?`, 'Fixed Invoice [' + searchKey.SendDCName + ']', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
    inputErrorMessage: 'input is required',
    inputPattern: /.+/,
  })
    .then(async ({ value }) => {
      const result = await profile.FixedConttractInvoiceFinance({ ContractNo: contentNumber, ReturnData: value, APIName: "Invoice", SendDCName: searchKey.SendDCName }).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => {

    })

};
//客户推送到金蝶
const PushAdvertiserToEAS = async (data) => {
  var name = JSON.parse(data).contractParty;
  ElMessageBox.confirm('Send Advertiser:' + name + ' ?', 'Warning', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {


      const result = await profile.PushAdvertiserToEAS1({ name: name }).then((res) => res);
      await search();
      ElMessage({
        message: result.data,
        type: 'success',
      });
    })
    .catch(() => { });
};
//数据推送到金蝶
const PushDataToEAS = async (InvoiceNumber) => {
  ElMessageBox.confirm('Send:' + InvoiceNumber + ' ?', 'Warning [' + searchKey.SendDCName + ']', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {
      const result = await profile.PushDataToEASInvoice({ InvoiceNumber: InvoiceNumber, SendDCName: searchKey.SendDCName }).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => { });
};

//范围日期数据推送到金蝶
const PushDateDataToEAS = async (data, searchType) => {
  console.log(1111, data, data.length);
  ElMessageBox.confirm('Send:  ' + data + ' ?', 'Warning [' + searchKey.SendDCName + ']', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {
      const result = await profile.PushDateDataInvoiceToEAS({ startTime: data[0], endTime: data[1], searchType: searchType, SendDCName: searchKey.SendDCName }).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => { });
};
//重启任务
const ResetScheduleEAS = async () => {
  ElMessageBox.confirm('Reset ?', 'Warning', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {
      const result = await profile.ResetScheduleEAS({}).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => { });
};
//停止任务
const StopScheduleEAS = async () => {
  ElMessageBox.confirm('Stop ?', 'Warning', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {
      const result = await profile.StopScheduleEAS({}).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => { });
};



//#endregion

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    searchKey[`${data.key}`] = data.value;
    search();
  });
});
</script>

<style scoped>
.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
